import { NgZone } from '@angular/core';

import { Observable, OperatorFunction } from 'rxjs';

// ensure that all lifecycle hooks of an observable are running in the ngzone
export function runInZone<T>(zone: NgZone): OperatorFunction<T, T> {
  return (source$: Observable<T>) => {
    return new Observable((observer$) => {
      return source$.subscribe({
        next: (value: T) => zone.run(() => observer$.next(value)),
        error: (e: any) => zone.run(() => observer$.error(e)),
        complete: () => zone.run(() => observer$.complete()),
      });
    });
  };
}
